import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import getText from 'context/language/getText';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';
import { useStyles } from './styled';

export const OverCreditLimit = ({ user }) => {
  const classes = useStyles();

  return (
    <div>
      <BodyLarge className={classes.error}>
        {getText('banners.overCreditLimit.title')}
      </BodyLarge>
      <BodyRegular className={classes.error}>
        {getText('banners.overCreditLimit.body', {
          displayCreditLimit: get(user, 'customer.displayCreditLimit', null),
        })}
      </BodyRegular>
    </div>
  );
};

OverCreditLimit.propTypes = {
  user: PropTypes.object
};

OverCreditLimit.defaultProps = {
  user: {}
};
